import _ from 'underscore';

import { I9nItemRefSortFields, I9nItemRefSortFieldsHelper } from '@biteinc/enums';

app.MenuSectionSortPrioritiesView = app.AccordionFieldView.extend({
  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {};
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const field = fieldGroupView.getValue();
        return I9nItemRefSortFieldsHelper.name(field.sortField);
      },
      templateData: {
        title: 'Menu Section Sort Priorities',
        buttonText: 'New Sort Priority',
        emptyText: 'No sort priorities yet',
      },
      newElementDropdown: {
        getCollection: () => {
          return app.AbstractCollection.createFromTsEnum({
            tsEnum: I9nItemRefSortFields,
            nameGenerator: I9nItemRefSortFieldsHelper.name,
            values: [I9nItemRefSortFields.Uncategorized],
          });
        },
        canShowModel: (sortField, elements) => {
          // Filter out the sort priorities that are already entered (but maybe not saved)
          return !_.findWhere(elements, { sortField: sortField.sortField });
        },
        getNewElementFromModel: (sortField) => {
          return {
            sortField: sortField.id,
          };
        },
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
